export * from './RoutesHistory/RoutesHistory';
export * from './Tracking/Tracking';
export { default } from './TrackingTab/TrackingTab';

export const IDLE_THRESHOLD_IN_MILLIS_WARN = 10 * 60 * 1000; // 10 minutes

export const ONE_HOUR_IN_MILLIS = 1 * 60 * 60 * 1000;
